import { formatCzDate } from "@/lib/date";
import type { Blog, BlogPost } from "@/types";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/24/outline";

type BlogPreviewGridProps = {
  blog: Blog;
  posts: BlogPost[];
  basePath: string;
  minimumItems?: number;
};

function stripHtml(value: string) {
  return value
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function BlogPreviewGrid({
  blog,
  posts,
  basePath,
  minimumItems = 0,
}: BlogPreviewGridProps) {
  const placeholderCount = Math.max(0, minimumItems - posts.length);

  return (
    <div className="blog-grid">
      {posts.map((post, index) => {
        const summary = stripHtml(
          post.summary ?? post.key_takeaways ?? post.content_html ?? "",
        );

        return (
          <Link
            href={`${basePath}/${post.url}`}
            prefetch={false}
            key={post.id}
            className={`blog-card ${index === 0 ? "blog-card--featured" : ""}`}
          >
            <div className="blog-card-body">
              <h2 className="blog-card-title !text-left text-softiq-primary">
                {post.title}
              </h2>
              {summary ? (
                <p className="blog-card-summary">{summary.slice(0, 320)}</p>
              ) : null}
              <div className="blog-card-footer">
                <span className="blog-card-meta">
                  {blog.author || "SOFTIQ"}
                  {post.publish_date || post.date_modified
                    ? ` · ${formatCzDate(
                        post.publish_date || post.date_modified,
                        {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        },
                      )}`
                    : null}
                </span>
                <span className="blog-card-cta">
                  Číst článek
                  <ArrowRightIcon />
                </span>{" "}
              </div>
            </div>
          </Link>
        );
      })}
      {Array.from({ length: placeholderCount }, (_, index) => (
        <div
          key={`placeholder-${index}`}
          aria-hidden
          className="blog-card invisible hidden min-h-[18rem] md:flex"
        >
          <div className="blog-card-body" />
        </div>
      ))}
    </div>
  );
}
